import { useEffect, useRef } from "react";

export function useAudio() {
  const clickSoundRef = useRef(null);
  const errorSoundRef = useRef(null);
  const moneySoundRef = useRef(null);

  useEffect(() => {
    clickSoundRef.current = new Audio('/sounds/click.mp3');
    clickSoundRef.current.volume = 0.3;
    clickSoundRef.current.preload = "auto";
    
    errorSoundRef.current = new Audio('/sounds/error.mp3');
    errorSoundRef.current.volume = 0.25;
    errorSoundRef.current.preload = "auto";

    moneySoundRef.current = new Audio('/sounds/money.mp3');
    moneySoundRef.current.volume = 0.4;
    moneySoundRef.current.preload = "auto";
    
    [clickSoundRef, errorSoundRef, moneySoundRef].forEach(sound => sound.current?.load());
  }, []);

  const playClick = () => {
    const audio = clickSoundRef.current;
    if (audio && audio.readyState >= 2) {
      audio.currentTime = 0;
      audio.play().catch(() => {});
    }
  };

  const playError = () => {
    const btn = document.querySelector('.contact-button');
    if (btn) {
      btn.style.background = 'red';
      setTimeout(() => btn.style.background = '', 200);
    }

    const audio = errorSoundRef.current;
    if (audio && audio.readyState >= 2) {
      audio.currentTime = 0;
      audio.play().catch(() => {});
    }
  };

  const playMoney = () => {
    const audio = moneySoundRef.current;
    if (audio && audio.readyState >= 2) {
      audio.currentTime = 0;
      audio.play().catch(() => {});
    }
  };

  return { playClick, playError, playMoney };
}
